import React from 'react';
import $ from 'jquery';
import config from '.././config.json';
import { Transfer, Select, Row, Col, Modal, Form, Input } from 'antd';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

import '../App.css';

const Option = Select.Option;
const FormItem = Form.Item;


class ChangeClasses extends React.Component {
    constructor(props) {
        super(props);

    }

    classInfo() {
        this.ajaxCall('GET', '/api/classes/getall',
            {}, (data) => {//success
                this.classData = [];
                for (let i = 0; i < data.length; i++) {

                    if (data[i].SystemName == this.state.filterSystem || this.state.filterSystem == "All") {
                        var date = data[i].StartDate.split('T')[0];
                        this.classData.push(
                            <Option key={data[i].Id} value={data[i].Id.toString()}>{data[i].Name + " " + date}</Option>
                        );
                    }
                }
                this.setState({
                    classList: this.classData
                });
            }, () => {//fail
                console.log('failed to get data');
            });
    }


    state = {
        mockData: [],
        targetKeys: [],
        valueA: '',
        valueB: '',
        login: true,
        classList: [],
        visibleWarning: false,
        filterSystem: "All"
    }

    filterOption = (inputValue, option) => {
        let desc = option.description.toUpperCase();
        return desc.indexOf(inputValue.toUpperCase()) > -1;
    }

    handleChange = (targetKeys) => {
        this.setState({ targetKeys });

    }


    handleChangeBoxA = (valueA) => {
        console.log(valueA);
        this.ajaxCall('GET', '/api/students/getclassstudents/' + valueA,
            {}, (data) => {//success
                console.log(data);
                var studentData = [];
                for (let i = 0; i < data.length; i++) {
                    studentData.push({
                        key: data[i].Id.toString(),
                        title: data[i].FirstName + " " + data[i].LastName,
                        description: data[i].FirstName + " " + data[i].LastName,
                    });
                }

                this.setState({
                    valueA,
                    mockData: studentData

                });

            }, () => {//fail
                console.log('failed to get data');
            });

    }

    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value });
        this.classInfo()
    }

    handleChangeBoxB = (valueB) => {
        console.log(valueB);
        this.setState({ valueB });
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div >
                {this.state.login ?
                    <div style={{ margin: 'auto', width: 860 }}>
                        <h2>Change Class</h2>
                        <hr />

                        <Row>
                            <Col span={24}>
                                System:
                                <br />
                                <Select
                                    style={{ width: 830 }}
                                    placeholder="Select the system the classes belong to"
                                    onChange={this.handleSelectChangeSystem}>
                                    <Option value="All">All</Option>
                                    <Option value="TCP">TCP</Option>
                                    <Option value="ESCC">ESCC</Option>
                                    <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                                </Select>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                From class:
                                <br />
                                <Select style={{ width: 830 }}
                                    value={this.state.valueA}
                                    placeholder={"Class A"}
                                    onChange={this.handleChangeBoxA}>
                                    {this.state.classList}
                                </Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                To class:
                                <br />
                                <Select style={{ width: 830 }}
                                    value={this.state.valueB}
                                    placeholder={"Class B"}
                                    onChange={this.handleChangeBoxB}>
                                    {this.state.classList}
                                </Select>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col span={24}>
                                <Transfer style={{ margin: 'auto', textAlign: 'center' }}
                                    dataSource={this.state.mockData}
                                    listStyle={{
                                        width: 400,
                                        height: 300,
                                    }}
                                    showSearch
                                    filterOption={this.filterOption}
                                    targetKeys={this.state.targetKeys}
                                    onChange={this.handleChange}
                                    render={item => item.title}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <br />
                            <button disabled={this.state.valueB == '' || this.state.targetKeys == ''} style={{ 'color': 'black', margin: 'auto', display: 'block' }} type="submit" className="btn btn-default color2" onClick={() => this.showModalW()}>Submit</button>
                            <br />
                            <p>Hint: Select Class A and select Class B, use the transfer box to transfer students from one class to the other.</p>
                        </Row>
                        <Modal
                            visible={this.state.visibleWarning}
                            title="Do you want to transfer the selected students?"
                            okText="Transfer"
                            onCancel={() => { this.onCancelW() }}
                            onOk={() => { this.onTransfer() }}
                        >
                            <Form>
                                <FormItem label="To receive a copy of the email notification. Enter your email:">
                                    {getFieldDecorator('EmailW', {
                                        rules: [{ required: true, message: 'Please input your email!', whitespace: true }],
                                    })(
                                        <Input />
                                    )}
                                </FormItem>
                            </Form>
                            Note: Separate multiple email using semicolon(;)
                        </Modal>
                    </div>
                    : <Redirect to="/login" replace />}
            </div>
        );
    }

    checkIntersection = (data, arr) => {


    }

    handleSubmit = (emailS) => {

        this.ajaxCall('GET', '/api/students/getclassstudents/' + this.state.valueB,
            {}, (data) => {//success
                console.log("Heres some data: ");
                console.log(data);
                var findOne = false;
                var data1 = this.state.targetKeys;
                var data2 = [];

                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < this.state.targetKeys.length; j++) {
                        if (data[i].Id == this.state.targetKeys[j]) {
                            data2.push(data[i]);
                            findOne = true;
                            var index = data1.indexOf(this.state.targetKeys[j].toString());
                            console.log(index);
                            if (index >= 0) {
                                data1.splice(index, 1);
                            }

                        }

                    }
                }
                this.handleChange(data1);
                this.handleChangeBoxA(this.state.valueA);

                if (findOne) {
                    var studentAlr = '';
                    for (let i = 0; i < data2.length; i++) {
                        studentAlr += data2[i].FirstName + " " + data2[i].LastName + " ,";

                    }
                    studentAlr = studentAlr.slice(0, -2);
                    Modal.error({
                        title: 'Already enrolled',
                        content: 'These students are already enrolled and would be removed from the list ' + studentAlr + ". Press submit again to continue.",
                    });

                }
                else {

                    this.ajaxCall('POST', '/api/classes/transfer/',
                        { students: this.state.targetKeys, classId: this.state.valueA, transferId: this.state.valueB, email: emailS }, (data) => {//success

                            this.classInfo();
                            this.setState({
                                mockData: [],
                                targetKeys: [],
                                valueA: '',
                                valueB: '',
                            });
                            Modal.success({
                                title: 'Transfer successful',
                            });
                        }, () => {//fail
                            console.log('failed to get data');
                        });

                }

            }, () => {//fail
                console.log('failed to get data');
            });


    }

    componentDidMount() {
        //this.getMock();
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.classInfo(); }); //login
    }

    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    showModalW = (e) => {

        this.setState({ visibleWarning: true });
    }
    onCancelW = () => {
        this.setState({ visibleWarning: false });
    }
    onTransfer = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            else {
                console.log('Received values of form: ', this.recordD);
                this.props.form.resetFields();
                this.setState({ visibleWarning: false });
                this.handleSubmit(values.EmailW);

            }
        });
    }

}

const WrappedChangeClasses = Form.create()(ChangeClasses);
export default WrappedChangeClasses;


// WEBPACK FOOTER //
// ./src/Admin/ChangeClasses.js